
































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Enums
import { RelatedProductsTypes } from "@/data/enums/products";
import { BrandConfigKeys, QUERY_PARAMS } from "@/data/constants";

// Types
import { IShopListItem } from "@/models/shop";
import { RawLocation } from "vue-router/types";
import { PromotionDisplayTypes } from "@/data/enums/promotions";

@Component
export default class ShopProductsListItem extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public item!: IShopListItem;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: () => ({}) })
  public isProcessing!: object;

  @Prop({ default: 70 })
  public truncateLength!: number;

  @Prop({ default: false })
  public categoryShortcut!: boolean;

  // Computed

  public get isWaiting() {
    // One or more shop item is processing
    return Object.keys(this.isProcessing).length;
  }

  public get isProduct() {
    return this.item.type === RelatedProductsTypes.PRODUCT;
  }

  public get ctaLabel() {
    return (
      this.item.label ||
      (this.isProduct
        ? this.$store.getters["ui/isMobile"]
          ? this.$t("_action.add")
          : this.$t("_action.add_to_basket")
        : this.$store.getters["ui/isMobile"]
        ? this.$t("_action.view")
        : this.$t("_action.view_products"))
    );
  }

  public get imagePath() {
    return this.$_.get(this.item, "image", false)
      ? `${this.$_.get(this.item, "image.full_url")}?size=400x400`
      : null;
  }

  public getPromoTags(item) {
    const displayType =
      this.$store.getters["brand/config"][BrandConfigKeys.SHOW_PROMOTION_AS] ||
      PromotionDisplayTypes.PERCENTAGE;
    const tooltip = item.hasMixedPromotions
      ? this.$t("_sentence.promotion.discount_will_be_auto_applied")
      : item.saving_summary;
    switch (displayType) {
      case PromotionDisplayTypes.NAME:
        return this.$_.map(item.promotionsByName, promo => ({
          label: promo,
          tooltip
        }));
      case PromotionDisplayTypes.PERCENTAGE:
        return [
          {
            label: item.hasMixedPromotions
              ? this.$t("_.on_promotion")
              : this.$t("_.save_percentage", {
                  percentage: item.saving_formatted
                }),
            tooltip
          }
        ];
      case PromotionDisplayTypes.LABEL:
      default:
        return [
          {
            label: this.$t("_.on_promotion"),
            tooltip
          }
        ];
    }
  }

  // Methods

  public async handleCtaClick($e, item) {
    // Allow default behaviour of eg. CMD + Click
    if ($e.metaKey || $e.altKey || $e.ctrlKey || $e.shiftKey) return;
    // Otherwise, prevent default behaviour
    $e.preventDefault();
    // If category, view category
    if (!this.isProduct) return this.viewCategory();
    // Update processing state
    this.$set(this.isProcessing, `${item.id}`, true);
    // Add to basket
    return this.$emit("addToBasket", item.product);
  }

  public handleRouteClick($event, navigate) {
    if (this.isWaiting) return;
    this.$emit("routing");
    navigate({ ...$event, defaultPrevented: false });
  }

  public handleReadMoreClick() {
    const route = this.item.route;
    if (!this.isProduct) return this.viewCategory();
    route.query[QUERY_PARAMS.READ_MORE] = "1";
    this.$router.push(route as RawLocation);
  }

  public viewCategory() {
    if (!this.categoryShortcut)
      return this.$emit("viewCategory", this.item.object_id);
    this.$router.push(this.item.route as RawLocation);
  }

  public getReadMoreHref($event) {
    return `${$event}&${QUERY_PARAMS.READ_MORE}=1`;
  }
}
